import { ApiPlugin } from "../../../assets/js/Diagram/plugins/plugins/ApiPlugin";
import { DataExportPlugin } from "../../../assets/js/Diagram/plugins/plugins/DataExportPlugin";
import { AdvancedLogicPlugin } from "../../../assets/js/Diagram/plugins/plugins/AdvancedLogicPlugin";
import { ExposeApiPlugin } from "../../../assets/js/Diagram/plugins/plugins/ExposeApiPlugin";
import { ApprovalMatrixPlugin } from "../../../assets/js/Diagram/plugins/plugins/ApprovalMatrixPlugin";
import { BlockchainEventPlugin } from "../../../assets/js/Diagram/plugins/plugins/BlockchainEventPlugin";
import { StartBlockchainEventPlugin } from "../../../assets/js/Diagram/plugins/plugins/StartBlockchainEventPlugin";
import { BlockchainPlugin } from "../../../assets/js/Diagram/plugins/plugins/BlockchainPlugin";
import { ExclusiveGatewayPlugin } from "../../../assets/js/Diagram/plugins/plugins/ExclusiveGatewayPlugin";
import { ExternalTaskPlugin } from "../../../assets/js/Diagram/plugins/plugins/ExternalTaskPlugin";
import { GeneralEndPlugin } from "../../../assets/js/Diagram/plugins/plugins/GeneralEndPlugin";
import { GeneralStartPlugin } from "../../../assets/js/Diagram/plugins/plugins/GeneralStartPlugin";
import { GenerateDocumentPlugin } from "../../../assets/js/Diagram/plugins/plugins/GenerateDocumentPlugin";
import { JoinGatewayPlugin } from "../../../assets/js/Diagram/plugins/plugins/JoinGatewayPlugin";
import { ParallelGatewayPlugin } from "../../../assets/js/Diagram/plugins/plugins/ParallelGatewayPlugin";
import { StartExternalPlugin } from "../../../assets/js/Diagram/plugins/plugins/StartExternalPlugin";
import { TaskPlugin } from "../../../assets/js/Diagram/plugins/plugins/TaskPlugin";
import { ProcessPlugin } from "../../../assets/js/Diagram/plugins/plugins/ProcessPlugin";

import { DataModelClass } from "../../../assets/js/Diagram/plugins/plugins/DataModel/DataModelClass";
import { ClassProperty } from "../../../assets/js/Diagram/plugins/plugins/DataModel/DataModelComponents/ClassProperty";
import { CircleDisplayPlugin } from "../../../assets/js/Diagram/plugins/plugins/AnchoredPlugins/CircleDisplayPlugin";

export const DIAGRAM_PLUGINS = {
    ExposeApiPlugin,
    DataExportPlugin,
    AdvancedLogicPlugin,
    ApiPlugin,
    ApprovalMatrixPlugin,
    BlockchainEventPlugin,
    StartBlockchainEventPlugin,
    BlockchainPlugin,
    ExclusiveGatewayPlugin,
    ExternalTaskPlugin,
    GeneralEndPlugin,
    GeneralStartPlugin,
    GenerateDocumentPlugin,
    JoinGatewayPlugin,
    ParallelGatewayPlugin,
    StartExternalPlugin,
    TaskPlugin,
    DataModelClass,
    ClassProperty,
    CircleDisplayPlugin,
    ProcessPlugin
};
